import { TaskDueDateOffset } from '../CRMIntegrationTaskSettings'

export type WealthboxInboundContactSyncSettingsFilters = {
  active?: boolean
  contactType?: string
  tags?: string[]
  type?: string
}

export type WealthboxInboundContactSyncSettings = {
  autoSync: boolean
  filters: WealthboxInboundContactSyncSettingsFilters
  tierTags?: string[]
}

export type WealthboxInboundSyncSettings = {
  contact: WealthboxInboundContactSyncSettings
}

export type WealthboxSettingsFormValues = {
  inbound: WealthboxInboundSyncSettings
  taskDueDateOffset?: TaskDueDateOffset
}

export const wealthboxSettingsDefaultValues: WealthboxSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
  },
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}

export const WEALTHBOX_ATTENDEE_SOURCES = ['invitees', 'linked_to', 'both'] as const

export type WealthboxAttendeeSource = (typeof WEALTHBOX_ATTENDEE_SOURCES)[number]

export const DEFAULT_WEALTHBOX_ATTENDEE_SOURCE: WealthboxAttendeeSource = 'invitees'

export const toWealthboxAttendeeSource = (value: unknown): WealthboxAttendeeSource =>
  WEALTHBOX_ATTENDEE_SOURCES.find((source) => source === value) ?? DEFAULT_WEALTHBOX_ATTENDEE_SOURCE
